'use strict';
import util from '../util';

var $cache;

function initializeCache() {
	$cache = {};
	$cache['errorMsg'] = $('#promotion-landing-container .landing-error');
}

function initializeEvents() {
	$(document)
		.on('submit', '#PromoLandingForm', function (e) {
			var httpParams = util.getQueryStringParams(util.getQueryString(window.location.href));
			$('<input type="hidden" name="promoid" value="' + httpParams["promoid"] + '" />').appendTo(e.target);
		})

		.on('focus', '#PromoLandingForm input', function () {
			$cache.errorMsg.hide();
		});
}

export default {
	init : function () {
	initializeCache();
	initializeEvents();

	if (window.location.href.indexOf('error') > -1) {
		$cache.errorMsg.show();
	}
	if (window.couponCode) {
		$("#promo-code").text(window.couponCode);
	}
}
}